import balanceStatementStorePage from './balanceStatementStorePage';

export default balanceStatementStorePage;